import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const getCompanyJobRoles = createAsyncThunk('getCompanyJobRoles', async (companyId, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/company/companies/job-roles?companyId=${companyId}`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const jobRolesSlice = createSlice({
    name: 'jobRolesSlice',
    initialState: {
        loading: false,
        jobRoles: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(getCompanyJobRoles.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getCompanyJobRoles.fulfilled, (state, action) => {
            state.loading = false;
            state.jobRoles = action.payload
        })
        builder.addCase(getCompanyJobRoles.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default jobRolesSlice.reducer